import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';
import { isConnectedAccount } from 'owa-accounts-store';
import type { MailboxInfo } from 'owa-client-types';
import { getConnectedAccountHeaders } from 'owa-connected-account-headers';
import { createDefaultHeaders } from 'owa-service/lib/createDefaultHeader';

import assign from 'object-assign';

export async function getDefaultRequestHeaders(
    mailboxInfo: MailboxInfo
): Promise<{ [headerName: string]: string }> {
    return createDefaultHeaders().then(async headers => {
        if (mailboxInfo) {
            if (isConnectedAccount(mailboxInfo.userIdentity)) {
                const connectedAccountHeaders = await getConnectedAccountHeaders(
                    mailboxInfo.userIdentity,
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2345 (20,21): Argument of type 'string | null' is not assignable to parameter of type 'string | undefined'.
                    // @ts-expect-error
                    mailboxInfo.type == 'GroupMailbox' || mailboxInfo.type == 'TeamsMailbox'
                        ? mailboxInfo.mailboxSmtpAddress
                        : null
                );
                assign(headers, connectedAccountHeaders);
            } else {
                if (mailboxInfo.type == 'GroupMailbox' || mailboxInfo.type == 'TeamsMailbox') {
                    const explicitLogonHeaders = getExplicitLogonHeaders(
                        mailboxInfo.mailboxSmtpAddress
                    );
                    assign(headers, explicitLogonHeaders);
                }
            }
        }

        return headers;
    });
}
